import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const slidesData = [
    {
        id: 1,
        title: "Quantum Computing",
        description: "Makers Lab explores quantum computing by building smarter qubits and algorithms, aiming to unlock faster problem-solving, stronger security, and new possibilities for future technology. "
    },
    {
        id: 2,
        title: "Metaverse",
        description: "Makers Lab explores Metaverse research by building immersive virtual worlds, digital twins, AI-powered experiences, shaping how people learn, collaborate and interact in future spaces together. "
    },
    {
        id: 3,
        title: "Foundational AI",
        description: "Makers Lab explores Foundational AI, building smarter core models and learning systems that push AI forward in a simple, ethical, and truly impactful way. "
    },
    {
        id: 4,
        title: "Our Innovation Labs ",
        description: "Makers Lab is our space for curiosity and creation, where ideas are explored without limits. It’s where we experiment with technology, design, and problem-solving to build real solutions. Together, our team learns, tests, and creates innovative products that turn imagination into practical impact for businesses and people in everyday life. "
    },
];

export default function ResearchSection() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
        breakpoints: {
            "(min-width: 640px)": {
                slides: { perView: 1.5, spacing: 20 },
            },
            "(min-width: 768px)": {
                slides: { perView: 2, spacing: 24 },
            },
            "(min-width: 1024px)": {
                slides: { perView: 3, spacing: 32 },
            },
        },
        slides: { perView: 1.1, spacing: 16 },
    });

    const isNextDisabled = () => {
        if (!instanceRef.current) return true;
        const totalSlides = instanceRef.current.track.details.slides.length;
        const perView = instanceRef.current.options.slides.perView;
        return currentSlide >= Math.ceil(totalSlides - perView);
    };

    return (
        <section className="w-full py-[40px] md:py-[80px] overflow-hidden font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <div className="mb-[24px] md:mb-[60px]">
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Areas of Research
                    </h2>
                </div>

                <div className="relative">
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden">
                        {slidesData.map((slide) => (
                            <div
                                key={slide.id}
                                className="keen-slider__slide"
                            >
                                <div className="group relative bg-white border border-[#01386A45] p-6 sm:p-8 flex flex-col justify-between h-[240px] sm:h-[280px] md:h-[320px] transition-shadow duration-300 hover:shadow-lg cursor-grab active:cursor-grabbing overflow-hidden rounded-sm">
                                    <div className="flex">
                                        <h3 className="text-[16px] md:text-[20px] font-[600] text-[#01386A] max-w-[85%] sm:max-w-[70%]">
                                            {slide.title}
                                        </h3>
                                    </div>
                                    <div className="mt-auto">
                                        <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik leading-relaxed font-medium">
                                            {slide.description}
                                        </p>
                                    </div>
                                    <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                                    <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-10"></div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-4 mt-6 md:mt-8">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.prev();
                                }}
                                disabled={currentSlide === 0}
                                className={`w-10 h-10 rounded-full border flex items-center justify-center transition-colors duration-300 ${currentSlide === 0
                                    ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                                    : 'border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white'
                                    }`}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.next();
                                }}
                                disabled={isNextDisabled()}
                                className={`w-10 h-10 rounded-full border flex items-center justify-center transition-colors duration-300 ${isNextDisabled()
                                    ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                                    : 'border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white'
                                    }`}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>

            </div>
        </section>
    );
}